/* fws-ship-estimator.js — estimator + strict inputs + de-dup fee lines */
(function () {
  const root = document.querySelector('#fws-ship-estimator');
  if (!root) return;

  /* ==== FREE FREIGHT PROMO: UI toggle + cart attribute ==== */
window.__ESTIMATOR_PROMO_SELECTED__ = false;

document.addEventListener('change', async (e) => {
  if (e.target && e.target.name === 'fws_delivery') {
    const val = e.target.value;
    // mark selected promo
    window.__ESTIMATOR_PROMO_SELECTED__ = (val === 'free_freight_promo');

    // store on cart for staff visibility
    const fd = new FormData();
    fd.append('attributes[selected_delivery_type]', val);
    try {
      await fetch('/cart/update.js', { method:'POST', body:fd, credentials:'same-origin' });
    } catch (_) {}
  }
});

  /* -------------------- ZONES & RATES -------------------- */
  const ZONE_BY_STATE = {
    AL:1, AR:1, KS:1, KY:1, LA:1, MS:1, MO:1, OK:1, TN:1, TX:1,
    AZ:2, FL:2, GA:2, NM:2, NC:2, SC:2,
    DE:3, MD:3, NJ:3, PA:3, VA:3, WV:3,
    CO:4, IL:4, IN:4, IA:4, MI:4, MN:4, NE:4, OH:4, SD:4, WI:4,
    CA:5, CT:5, ID:5, ME:5, MA:5, NH:5, NY:5, ND:5, RI:5, UT:5, VT:5,
    NV:6, OR:6, WA:6
  };

  // A: 5 & 15 gal | B: 55 gal & Hot Water Pressure Washer | C: 275-gal tote
  const RATES_USD = {
    profileA: {
      1:[135,175,225,275], 2:[135,200,250,300], 3:[165,250,350,400],
      4:[150,225,300,375], 5:[200,300,425,500], 6:[200,370,520,615]
    },
    profileB: {
      1:[175,225,275,400], 2:[200,250,300,475], 3:[250,350,400,725],
      4:[225,300,375,525], 5:[300,425,500,825], 6:[370,520,615,1100]
    },
    profileC: {
      1:[300,440,650,855], 2:[295,450,660,745], 3:[470,745,1100,1320],
      4:[370,550,825,1100], 5:[500,800,1190,1575], 6:[690,1200,1790,2380]
    }
  };

  // Keep fees here for math (these are the logical dollar amounts)
  const EXTRA_FEES = { residential:40, liftgate:20, terminal:35, notify:10 };

  // Fee product variant IDs must be defined in the snippet:
  // window.FWS_FEE_VARIANTS = { residential: <id>, liftgate: <id>, terminal: <id>, notify: <id> }
  const FEE = window.FWS_FEE_VARIANTS || {};
  const ALL_FEE_IDS = Object.values(FEE).filter(Boolean).map(Number);

  const lc = s => (s||'').toString().trim().toLowerCase();

  /* -------------------- VARIANT HELPERS -------------------- */
  let variantMap = null; // { id:title }

  function buildVariantMap() {
    if (variantMap) return;
    const ta = document.querySelector('textarea[data-variant-json]');
    if (ta) {
      try {
        const arr = JSON.parse(ta.value || ta.textContent || '');
        if (Array.isArray(arr)) {
          variantMap = {};
          arr.forEach(v => v?.id && (variantMap[Number(v.id)] = v.title || ''));
        }
      } catch(e){}
    }
    if (!variantMap && window.ShopifyAnalytics?.meta?.product?.variants) {
      variantMap = {};
      (window.ShopifyAnalytics.meta.product.variants || []).forEach(v => {
        if (v?.id) variantMap[Number(v.id)] = v.name || v.public_title || v.title || '';
      });
    }
    if (!variantMap) {
      const sel = document.querySelector('form[action*="/cart/add"] select[name="id"]');
      if (sel) {
        variantMap = {};
        Array.from(sel.options).forEach(opt => variantMap[Number(opt.value)] = (opt.textContent||'').trim());
      }
    }
  }

  function currentVariantId() {
    const idField = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (idField?.value) return Number(idField.value);
    const sa = window.ShopifyAnalytics?.meta?.selectedVariantId;
    if (sa) return Number(sa);
    const sel = document.querySelector('form[action*="/cart/add"] select[name="id"]');
    if (sel?.value) return Number(sel.value);
    return null;
  }

  function currentVariantTitle() {
    const cv = document.querySelector('textarea[data-current-variant-json]');
    if (cv && cv.value) { try { const v = JSON.parse(cv.value); if (v?.title) return v.title; } catch(e){} }
    const id = currentVariantId();
    buildVariantMap();
    if (id && variantMap?.[id]) return variantMap[id];

    const chosenBtn = document.querySelector('.variant-input input[type="radio"]:checked + label, .variant-input .is-selected, .product-form__input input[type="radio"]:checked + label');
    if (chosenBtn) return chosenBtn.textContent.trim();

    const sel = document.querySelector('form[action*="/cart/add"] select[name="id"]');
    if (sel?.selectedOptions?.[0]) return sel.selectedOptions[0].textContent.trim();

    return '';
  }

  function productTitle() {
    const t = document.querySelector('.product-single__title, .product__title, h1.product-title');
    return t ? t.textContent.trim() : (window.ShopifyAnalytics?.meta?.product?.name || '');
  }

  /* -------------------- PROFILE & WEIGHT (incl. bundle titles) -------------------- */
  function parseBundleGallons(vt) {
    const m = (vt||'').match(/\b(275|55|15|5)\b\s*(?:-?\s*gallon)?\s+bundle\b/i);
    return m ? Number(m[1]) : null;
  }

  function detectProfile(vTitle, pTitle) {
    const vt = lc(vTitle), pt = lc(pTitle);
    const bundleGallons = parseBundleGallons(vt);
    if (bundleGallons != null) {
      if (bundleGallons === 275) return 'profileC';
      if (bundleGallons === 55)  return 'profileB';
      return 'profileA'; // 5 or 15
    }
    if (pt.includes('hot water pressure washer')) return 'profileB';
    if (vt.includes('275') && vt.includes('tote')) return 'profileC';
    if (vt.includes('55')  && vt.includes('drum')) return 'profileB';
    if (vt.includes('15')  && vt.includes('drum')) return 'profileA';
    if (vt.includes('5 gallon') || vt.includes('5 gallons')) return 'profileA';
    return 'profileA';
  }

  function unitWeight(vTitle, pTitle) {
    const vt = lc(vTitle), pt = lc(pTitle);
    const bundleGallons = parseBundleGallons(vt);
    if (bundleGallons != null) {
      if (bundleGallons === 275) return 5000;
      if (bundleGallons === 55)  return 1000;
      if (bundleGallons === 15)  return  300;
      if (bundleGallons === 5)   return  100;
    }
    if (pt.includes('hot water pressure washer')) return 0; // forces top tier of B via tierIndex
    if (vt.includes('275') && vt.includes('tote')) return 2500;
    if (vt.includes('55')  && vt.includes('drum')) return 500;
    if (vt.includes('15')  && vt.includes('drum')) return 150;
    if (vt.includes('5 gallon') || vt.includes('5 gallons')) return 50;
    return 0;
  }

  function tierIndex(profile, totalLbs, pTitle) {
    if (lc(pTitle).includes('hot water pressure washer')) return 3;
    if (profile === 'profileA') return (totalLbs<=500)?0:(totalLbs<=1000)?1:(totalLbs<=1500)?2:3;
    if (profile === 'profileB') return (totalLbs<=1000)?0:(totalLbs<=1500)?1:(totalLbs<=2000)?2:3;
    return (totalLbs<=2500)?0:(totalLbs<=5000)?1:(totalLbs<=7500)?2:3; // profileC
  }

  /* -------------------- UI helpers -------------------- */
  function choiceUI() {
    const st = (root.querySelector('#fws-state')?.value || '').toUpperCase();
    const delEl = root.querySelector('input[name="fws_delivery"]:checked');
    const delivery = delEl ? delEl.value : '';
    const notify = !!root.querySelector('#fws-notify:checked');
    const zip = (root.querySelector('#fws-zip')?.value || '').trim();
    return { state: st, delivery, notify, zip };
  }

  function qty() {
    const qEl = document.querySelector('form[action*="/cart/add"] [name="quantity"], .js-qty__num, input.qty, input[type="number"][name="quantity"]');
    const n = parseInt(qEl?.value || '1', 10);
    return (isFinite(n) && n > 0) ? n : 1;
  }

  function labelFor(delivery, notify) {
    let s = delivery === 'residential_liftgate' ? 'Residential + Liftgate'
          : delivery === 'terminal' ? 'Local Terminal Pickup'
          : delivery === 'pickup_okc' ? 'Warehouse Pickup in OKC (Free)'
          : 'Commercial with Forklift';
    if (notify && delivery !== 'pickup_okc') s += ' + Notify before delivery';
    return s;
  }

  function canEstimate(delivery, zip, state) {
    if (delivery === 'pickup_okc') return true;
    return !!(zip && state);
  }

  function setResult(text) {
    const out = root.querySelector('#fws-result');
    if (out) out.textContent = text;
  }

    /* -------------------- Promo eligibility (PDP) -------------------- */
  function isWasherProduct(pTitle) {
    return lc(pTitle).includes('hot water pressure washer');
  }

  function variantAllowsPromo(vTitle, pTitle) {
  // Block whole product if it's the washer
  if (isWasherProduct(pTitle)) return false;

  const vtRaw = vTitle || '';
  const vt = lc(vtRaw);

  // Disallow 5-gal and 275-gal (and totes/IBC) outright
  const is5    = /\b5\b\s*-?\s*gallon(s)?\b/.test(vt);
  const is275  = /\b275\b\s*-?\s*gallon(s)?\b/.test(vt);
  const isTote = vt.includes('tote') || vt.includes('ibc');
  if (is5 || is275 || isTote) return false;

  // Bundles: allow only 15/55 bundles (your parser reads the original-case string)
  const bundleGallons = parseBundleGallons(vtRaw);
  if (bundleGallons != null) {
    return bundleGallons === 15 || bundleGallons === 55;
  }

  // Singles: allow any 15- or 55-gallon that is NOT a bundle
  const mentionsBundle = vt.includes('bundle');
  const is15 = /\b15\b\s*-?\s*gallon(s)?\b/.test(vt);
  const is55 = /\b55\b\s*-?\s*gallon(s)?\b/.test(vt);

  return (is15 || is55) && !mentionsBundle;
}

  function setPromoEnabledUI(enabled) {
    const promoInput = root.querySelector('input[name="fws_delivery"][value="free_freight_promo"]');
    const promoWrap  = root.querySelector('.fws-option--promo');
    if (!promoInput) return;

    // Disable/enable
    promoInput.disabled = !enabled;
    promoInput.setAttribute('aria-disabled', String(!enabled));

    // If it was selected but is no longer allowed, unselect & clear flag
    if (!enabled && promoInput.checked) {
      promoInput.checked = false;
      window.__ESTIMATOR_PROMO_SELECTED__ = false;
      promoInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Optional: hide the row entirely when not allowed
    if (promoWrap) promoWrap.style.display = enabled ? '' : 'none';
  }

  function evaluatePromoEligibilityAndApply() {
    const vTitle = currentVariantTitle();
    const pTitle = productTitle();
    const allowed = variantAllowsPromo(vTitle, pTitle);
    setPromoEnabledUI(allowed);
    return allowed;
  }
  
  /* -------------------- Estimator display -------------------- */
function calc() {
  // Keep the Free Freight Promo radio in sync with the current PDP variant/product
  const promoAllowed = evaluatePromoEligibilityAndApply();

  // Only short-circuit if promo is selected AND allowed
  if (window.__ESTIMATOR_PROMO_SELECTED__ && promoAllowed) {
    setResult('Free Freight Promo');
    return;
  }

  const { state, delivery, notify, zip } = choiceUI();
  if (!delivery) {
    setResult('Enter ZIP, select state, and choose a delivery type to see shipping.');
    return;
  }
  if (!canEstimate(delivery, zip, state)) {
    setResult('Enter ZIP and select state to calculate shipping.');
    return;
  }

  if (delivery === 'pickup_okc') {
    setResult(`Estimated shipping: $0.00 — ${labelFor(delivery, notify)}`);
    return;
  }

  const zone = ZONE_BY_STATE[state];
  if (!zone) {
    setResult('Sorry — we do not ship to your state.');
    return;
  }

  const vTitle = currentVariantTitle();
  const pTitle = productTitle();
  const profile = detectProfile(vTitle, pTitle);
  const lbs = unitWeight(vTitle, pTitle) * qty();
  const tIdx = tierIndex(profile, lbs, pTitle);
  const base = RATES_USD[profile]?.[zone]?.[tIdx];
  if (base == null) {
    setResult('Shipping unavailable for this selection.');
    return;
  }

  let fees = 0;
  if (delivery === 'residential_liftgate') fees += (EXTRA_FEES.residential + EXTRA_FEES.liftgate);
  if (delivery === 'terminal')             fees += EXTRA_FEES.terminal;
  if (notify)                               fees += EXTRA_FEES.notify;

  setResult(`Estimated shipping: $${(base + fees).toFixed(2)} — ${labelFor(delivery, notify)}`);
}

  function readDisplayedEstimateCents() {
    const out = document.querySelector('#fws-result');
    if (!out) return null;
    const m = (out.textContent || '').match(/\$([\d,.]+)/);
    if (!m) return null;
    const dollars = Number(m[1].replace(/,/g, ''));
    if (!isFinite(dollars)) return null;
    return Math.round(dollars * 100);
  }

  /* -------------------- Events to keep calc fresh -------------------- */
  root.addEventListener('change', (e) => {
    if (e.target.name === 'fws_delivery') {
      root.querySelectorAll('.fws-option').forEach(o => o.classList.remove('selected'));
      const lbl = e.target.closest('.fws-option'); if (lbl) lbl.classList.add('selected');
      const h = document.querySelector('input[name="attributes[fws_delivery]"]'); if (h) h.value = e.target.value;
      const notifyEl = root.querySelector('#fws-notify');
      if (notifyEl) {
        if (e.target.value === 'pickup_okc') { notifyEl.checked = false; notifyEl.disabled = true; }
        else { notifyEl.disabled = false; }
      }
      calc();
    }
    if (e.target.name === 'fws_notify') {
      const h2 = document.querySelector('input[name="attributes[fws_notify]"]'); if (h2) h2.value = e.target.checked ? 'yes' : '';
      calc();
    }
    if (e.target.id === 'fws-state') {
      e.target.classList.toggle('has-value', !!e.target.value);
      calc();
    }
  });
  document.addEventListener('input', (e) => {
    if (e.target.matches('[name="quantity"], .js-qty__num, input.qty, input[type="number"][name="quantity"]')) calc();
    if (e.target.id === 'fws-zip') calc();
  });
  document.addEventListener('change', (e) => { if (e.target.matches('select[name="id"]')) calc(); });

  const idField = document.querySelector('form[action*="/cart/add"] [name="id"]');
  if (idField) {
    new MutationObserver(() => calc()).observe(idField, { attributes:true, attributeFilter:['value'] });
    idField.addEventListener('input', calc);
    idField.addEventListener('change', calc);
  }
  document.addEventListener('click', () => setTimeout(calc, 0), true);
  ['variant:change','variant:changed','product:variant-change','theme:variant:change'].forEach(evt=>{
    document.addEventListener(evt, () => calc(), true);
  });
  calc();

  /* -------------------- Cart helpers -------------------- */
  async function getCart(){ const r = await fetch('/cart.js',{credentials:'same-origin'}); return r.json(); }
  async function setCartAttributes(attrs){
    const fd = new FormData(); Object.entries(attrs).forEach(([k,v])=>fd.append(`attributes[${k}]`, v));
    await fetch('/cart/update.js',{method:'POST',body:fd,credentials:'same-origin'});
  }
  async function addMultiple(items){
    const r = await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items}),credentials:'same-origin'});
    if (!r.ok) throw new Error('Add failed');
    return r.json();
  }

  /* Figure out fee “kind” by variant_id */
  function kindForVariantId(vid) {
    if (Number(vid) === Number(FEE.residential)) return 'residential';
    if (Number(vid) === Number(FEE.liftgate))    return 'liftgate';
    if (Number(vid) === Number(FEE.terminal))    return 'terminal';
    if (Number(vid) === Number(FEE.notify))      return 'notify';
    return null;
  }

  /* Ensure cart has exactly one of each desired fee kind; remove others/dupes */
  async function normalizeFeeLines(desiredKinds) {
    const desired = new Set(desiredKinds || []);
    const cart = await getCart();

    const updates = {};
    const kept = new Set(); // which kinds we’ve kept one of

    cart.items.forEach(item => {
      const isFeeByProp = item.properties && item.properties._shippingFee === '1';
      const kind = kindForVariantId(item.variant_id);
      const isFee = isFeeByProp || (ALL_FEE_IDS.includes(Number(item.variant_id)));

      if (!isFee) return;

      if (!kind || !desired.has(kind)) {
        // Not wanted anymore
        updates[item.key] = 0;
        return;
      }

      if (kept.has(kind)) {
        // duplicate for same kind — remove
        updates[item.key] = 0;
        return;
      }

      // keep this one; enforce qty = 1
      kept.add(kind);
      if (item.quantity !== 1) updates[item.key] = 1;
    });

    // Apply removals/qty fixes first
    if (Object.keys(updates).length) {
      await fetch('/cart/change.js', {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ updates }),
        credentials:'same-origin'
      });
    }

    // Add any missing kinds
    const itemsToAdd = [];
    ['residential','liftgate','terminal','notify'].forEach(kind => {
      if (desired.has(kind) && !kept.has(kind) && FEE[kind]) {
        itemsToAdd.push({
          id: Number(FEE[kind]),
          quantity: 1,
          properties: { _shippingFee:"1", _feeType:kind }
        });
      }
    });

    if (itemsToAdd.length) {
      await addMultiple(itemsToAdd);
    }
  }

  /* -------------------- Add to cart flow -------------------- */
  function requireValidSelection(e) {
    // Allow add-to-cart with Promo selected (no delivery/zip/state required)
if (window.__ESTIMATOR_PROMO_SELECTED__) {
  return false; // do NOT block submission
}
    const { delivery, zip, state } = choiceUI();
    if (!delivery) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      alert('Please select a delivery type before adding to cart.');
      return true;
    }
    if (delivery !== 'pickup_okc' && (!zip || !state)) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      alert('Please enter ZIP and select state to calculate shipping before adding to cart.');
      return true;
    }
    return false;
  }

  function computeBaseCentsFallback() {
    const { state, delivery } = choiceUI();
    if (delivery === 'pickup_okc') return 0;
    const zone = ZONE_BY_STATE[state];
    const vTitle = currentVariantTitle();
    const pTitle = productTitle();
    const profile = detectProfile(vTitle, pTitle);
    const lbs = unitWeight(vTitle, pTitle) * qty();
    const tIdx = tierIndex(profile, lbs, pTitle);
    const base = (zone && RATES_USD[profile]?.[zone]?.[tIdx]) || 0;
    return Math.round(Number(base) * 100);
  }

  function labelForCart(delivery, notify) { return labelFor(delivery, notify); }

  async function primeAttributesAndFees() {
    const { state, zip, delivery, notify } = choiceUI();

    // Logical fee kinds for this selection (independent of IDs)
    const kinds = [];
    if (delivery === 'residential_liftgate') kinds.push('residential','liftgate');
    if (delivery === 'terminal')             kinds.push('terminal');
    if (notify && delivery !== 'pickup_okc') kinds.push('notify');

    // How many fee dollars did the customer see in the estimate?
    let feeLinesCents = 0;
    if (kinds.includes('residential')) feeLinesCents += EXTRA_FEES.residential * 100;
    if (kinds.includes('liftgate'))    feeLinesCents += EXTRA_FEES.liftgate * 100;
    if (kinds.includes('terminal'))    feeLinesCents += EXTRA_FEES.terminal * 100;
    if (kinds.includes('notify'))      feeLinesCents += EXTRA_FEES.notify * 100;

    const shownCents = readDisplayedEstimateCents();
    let baseCents = 0;
    if (delivery === 'pickup_okc') {
      baseCents = 0;
    } else if (shownCents != null) {
      baseCents = Math.max(0, shownCents - feeLinesCents);
    } else {
      baseCents = computeBaseCentsFallback();
    }

    await setCartAttributes({
      fws_delivery: delivery,
      fws_notify: notify ? 'yes' : 'no',
      fws_state: state || '',
      fws_zip: zip || '',
      fws_base_cents: String(baseCents || 0),
      fws_choice_label: labelForCart(delivery, notify)
    });

    // Make fee lines match exactly (no dupes)
    await normalizeFeeLines(kinds);
  }

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    if (requireValidSelection(e)) return;
    e.stopPropagation();
    (async () => { try { await primeAttributesAndFees(); form.submit(); } catch(_) { form.submit(); } })();
    e.preventDefault();
  }, true);

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('button[name="add"], [type="submit"][name="add"], .product-form__submit, .add-to-cart');
    if (!btn) return;
    if (requireValidSelection(e)) return;
    e.stopPropagation();
    e.preventDefault();
    (async () => {
      try { await primeAttributesAndFees(); } catch(_) {}
      const form = btn.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      if (form) form.submit();
      else btn.click();
    })();
  }, true);
})();